import React, { useContext } from "react";
import i18next from "../localization/i18n";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import SaitRowAction from "./SaitRowAction";
import { setGlobalConfirm } from "../store/globalConfirmReducer";
import { useDispatch } from "react-redux";
import { ModuleContext, saitfecoreNs } from "../utils/Constants";

/*
	Obbligatori:
		id
		description
		onConfirm
	Facoltativi:
		onCancel
*/

export default function SaitRowActionDelete(props) {
	const dispatch = useDispatch();
	const module = useContext(ModuleContext);

	return SaitRowAction({
		id: props.id,
		icon: <RemoveCircleIcon color="error" />,
		tooltip: props.annullato ? i18next.t("cancel", { ns: saitfecoreNs }) : i18next.t("delete", { ns: saitfecoreNs }),
		objmod: props.objmod,
		onClick: (params) => {
			const finalDesc = props.description(params);
			const constConfirmMessage = props.annullato ? "cancel_row_desc" : "delete_row_desc";

			dispatch(
				setGlobalConfirm({
					module: module,
					confirmMessage: i18next.t(constConfirmMessage, {
						desc: finalDesc,
						ns: saitfecoreNs,
					}),
					onConfirm: function () {
						props.onConfirm?.(params);
					},
					onCancel: function () {
						props.onCancel?.(params);
					},
				}),
			);
		},
		conditionalRendering: props.conditionalRendering,
		roleSecurity: props.roleSecurity,
		hidden: props.hidden,
	});
}
